// App-wide constants and environment config.
// Only VITE_-prefixed vars are available here (exposed by Vite to the client).

export const config = {
  // Strip any trailing slash(es) — consumers always prepend their own leading
  // slash, and infra has flipped this env var between with/without before.
  apiUrl: (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, ''),
  appUrl: import.meta.env.VITE_APP_URL ?? '',
  // Documentation site for this environment. The docs are deployed per
  // environment, so the portal must link to the docs that match the API it
  // talks to — a dev portal pointing at production docs is misleading.
  // A full URL (not a subdomain prefix) so a new environment needs no code change.
  docsUrl: import.meta.env.VITE_DOCS_URL ?? 'https://documentation.moveris.com',
  // Social OAuth — set these env vars to enable social login buttons
  googleAuthUrl: import.meta.env.VITE_GOOGLE_AUTH_URL ?? '',
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
  githubAuthUrl: import.meta.env.VITE_GITHUB_AUTH_URL ?? '',
  githubClientId: import.meta.env.VITE_GITHUB_CLIENT_ID ?? '',
  socialRedirectUri: import.meta.env.VITE_SOCIAL_REDIRECT_URI ?? '',
  appEnv: import.meta.env.VITE_APP_ENV ?? 'local',
  commitSha: import.meta.env.VITE_COMMIT_SHA ?? '',
  appVersion: __APP_VERSION__,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export * from './countries';
